<!DOCTYPE html>
<template>
<div class="admin"
  v-if="isAdmin">

  <div class="sidemenu">
    <div class="nav">

      <div>
        <div class="uppercaseheader">Sections</div>
        <b-list-group>
          <b-list-group-item v-for="s in sections"
                             button
                             :key="s.id"
                             :active="s.id == sectionId"
                             @click="changeSection(s)">
            {{s.name}}
          </b-list-group-item>
        </b-list-group>
      </div>


    </div>
  </div>

  <div v-if="section"
       class="content">

    <Item v-if="item"
          :section="section"
          :item="item"
          @close="close" />

    <Table v-else
           :section="section"
           :items="items"
           @add-new="addNew"
           @row-clicked="rowClicked" />

  </div>

</div>
</template>

<script>
//Firebase
const firebase = require( '../firebaseConfig.js' )
const users = firebase.db.collection( 'users' )
//Models
const Client = require( '@/models/Client.js' )
const Skill = require( '@/models/Skill.js' )
const Preference = require( '@/models/Preference.js' )
const Project = require( '@/models/Project.js' )
const Provider = require( '@/models/Provider.js' )
const Goal = require( '@/models/Goal.js' )
//Components
import Item from '@/components/admin/Item.vue'
import Table from '@/components/admin/Table.vue'
// Mixins
import { Actions } from '@/mixins/Mixins.js'
export default {
  name: 'Admin',
  metaInfo() {
    return {
      title: 'Admin',
      meta: [
        { name: "description", content: "Admin" },
        { name: "twitter:title", content: "BlueTeam", vmid: 'twitter:title' },
        { name: "og:image", content: "https://getblueteam.com/img/BlueTeamLogo.bb7395fa.png" },
        { name: "twitter:description", content: 'Administrative', vmid: 'twitter:description' },
        { name: "keywords", content: "cybersecurity, talent, fintech, digital health, appsec, IAM, identity management, devsecops, devops, cloud security" }
      ]
    }
  },
  components: {
    Item,
    Table,
  },
  mixins: [ Actions ],
  props: {
    user: Object,
    itemId: String,
    sectionId: String,
  },
  watch: {
    user: {
      immediate: true,
      handler( user ) {
        if ( user ) {
          this.$bind( 'userData', users.doc( user.uid ) )
        }
      },
    },
    hasSectionAndId( newVal, ) {
      if ( newVal ) {
        this.$bind( 'item', firebase.db
          .collection( this.section.db )
          .doc( this.itemId ) )
      } else {
        this.item = null
      }
    },
  },
  created() {
    /*
    On create, populate `sections` with the all models we've imported.
    This will dictate what shows up in the sidebar, and pass on
    needed info to further components
    */
    this.sections = [
      Provider.info,
      Client.info,
      Project.info,
      Skill.info,
      Preference.info,
      Goal.info,
    ]
  },
  data() {
    return {
      userData: null,
      item: null,
      sections: [],
      projects: [],
      clients: [],
      providers: [],
      skills: [],
      preferences: [],
      goals: [],
    }
  },
  firestore: {
    goals: firebase.db.collection( 'goals' ),
    skills: firebase.db.collection( 'skills' ),
    projects: firebase.db.collection( 'projects' ),
    preferences: firebase.db.collection( 'preferences' ),
    clients: firebase.db.collection( 'users' ).where( 'type', '==', 'client' ),
    providers: firebase.db.collection( 'users' ).where( 'type', '==', 'provider' ),
  },
  computed: {
    section() {
      return this.sections.find( s => s.id == this.sectionId )
    },
    items() {
      return this[ this.sectionId ]
    },

    hasSectionAndId() {
      if ( this.itemId ) {
        if ( this.section ) {
          return this.itemId + '/' + this.section.id
        }
      }
      return false
    },
    isAdmin() {
      if ( this.userData ) {
        return this.userData.type === 'admin'
      }
      return false
    },
  },
  methods: {
    changeSection( newSection ) {
      this.$router.push( `/admin/${newSection.id}` ).catch( () => {} )
    },
    rowClicked( record ) {
      this.$router.push( `/admin/${this.sectionId}/${record.id}` ).catch( () => {} )
    },
    close() {
      this.reset()
    },
    reset() {
      this.$router.push( `/admin/${this.sectionId}` ).catch( () => {} )
    },
    addNew( section ) {
      if ( section.id == 'providers' || section.id == 'clients' ) {
        let emailAddress = prompt( "Please enter a new email address" );
        if ( emailAddress && emailAddress != '' ) {
          let defaultPassword = '1234567890'
          this.createAccount( emailAddress, defaultPassword, { email: emailAddress, type: section.single.toLowerCase() } ).then( ( result ) => {
            this.$router.push( `/admin/${section.id}/${result.id}` ).catch( () => {} )
          } )
        }
      } else {
        this.createOther( {}, section ).then( ( result ) => {
          this.$router.push( `/admin/${section.id}/${result.id}` ).catch( () => {} )
        } )
      }
    },
  }
}
</script>


<style scoped lang="scss">
@import "@/styles/global.scss";

.admin {
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: 1fr 5fr;
    grid-column-gap: 1rem;
    min-height: 70vh;
    color: $primary;

    .sidemenu {
        display: grid;
        grid-template-rows: 5rem auto 1fr;
        .nav {
            display: grid;
            grid-row-gap: 1rem;
        }
    }

    .content {
        min-height: 70vh;
        grid-column: 2;
        background: theme-color-level('primary', -12);
        padding: 2rem;
        border-radius: 1rem;
    }

}
</style>
